"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardLoader = void 0;
const pino_1 = __importDefault(require("pino"));
const react_router_1 = require("react-router");
const appConstants_1 = require("../../../constants/appConstants");
const currenciesQuery_1 = require("../../../queries/currenciesQuery");
const dashboardQuery_1 = require("../../../queries/dashboardQuery");
const teamQuery_1 = require("../../../queries/teamQuery");
const userQuery_1 = require("../../../queries/userQuery");
const userSelectors_1 = require("../../../selectors/userSelectors");
const logger = (0, pino_1.default)();
const dashboardLoader = async ({ queryClient, params, }) => {
    const teamDataQuery = (0, teamQuery_1.teamQuery)({ teamId: params.teamId });
    const currencies = await queryClient.ensureQueryData((0, currenciesQuery_1.getCurrenciesQuery)(undefined));
    const selectedTeamId = await queryClient.ensureQueryData((0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'));
    let hasCompanyAccess;
    try {
        const props = {
            objectId: 'company_settings',
            operationId: 'view',
            groupId: undefined,
            teamId: undefined,
            userId: undefined,
        };
        hasCompanyAccess = await queryClient.ensureQueryData((0, userQuery_1.getVerifyUserAccessQuery)(props));
    }
    catch (error) {
        logger.error({ error });
    }
    const user = await queryClient.ensureQueryData(userQuery_1.userQuery);
    const userRole = (0, userSelectors_1.isCompanyOrSupportAdmin)(user.roles)
        ? appConstants_1.overviewConstants.COMPANY_ADMIN
        : user.roles.find(role => role.securityGroupId === String(selectedTeamId))?.roleId || '';
    let dashboardMetrics;
    let teamName;
    let initialTeam;
    if ((0, userSelectors_1.isCompanyOrSupportAdmin)(user.roles) && !params.teamId) {
        const companyMetricsQuery = (0, dashboardQuery_1.getCompanyMetricsQuery)();
        dashboardMetrics = await queryClient.ensureQueryData({
            queryKey: companyMetricsQuery.queryKey,
            queryFn: companyMetricsQuery.queryFn,
        });
    }
    else if (((0, userSelectors_1.isCompanyOrSupportAdmin)(user.roles) && params.teamId) || userRole === appConstants_1.teamAdmin) {
        const teamMetricsQuery = (0, dashboardQuery_1.getTeamMetricsQuery)(params.teamId || '');
        dashboardMetrics = await queryClient.ensureQueryData({
            queryKey: teamMetricsQuery.queryKey,
            queryFn: teamMetricsQuery.queryFn,
        });
        const team = await queryClient.ensureQueryData(teamDataQuery);
        initialTeam = team;
        teamName = team.name;
    }
    else if (userRole === appConstants_1.manager) {
        const managerMetricsQuery = (0, dashboardQuery_1.getManagerMetricsQuery)(params.teamId || '');
        dashboardMetrics = await queryClient.ensureQueryData({
            queryKey: managerMetricsQuery.queryKey,
            queryFn: managerMetricsQuery.queryFn,
        });
        const team = await queryClient.ensureQueryData(teamDataQuery);
        teamName = team.name;
        initialTeam = team;
    }
    else {
        return (0, react_router_1.redirect)('/wallet/my-cards');
    }
    return {
        user,
        initialTeam,
        hasCompanyAccess,
        teamId: params.teamId,
        dashboardMetrics,
        teamName,
        currency: currencies?.[0] || 'USD',
        settlements: [],
        isCompanyDashboard: (0, userSelectors_1.isCompanyOrSupportAdmin)(user.roles) && !params.teamId,
        isCompanyTeamDashboard: ((0, userSelectors_1.isCompanyOrSupportAdmin)(user.roles) && params.teamId) || (0, userSelectors_1.isTeamAdmin)(user.roles),
        isManagerDashboard: (0, userSelectors_1.isManager)(user.roles),
    };
};
exports.dashboardLoader = dashboardLoader;
